
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { useAvatarBundleList } from '@/modules/avatar/bundle/model/list';
import { AvatarBundleOptions } from '@/modules/avatar/bundle/model/mixins';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';
import { InjectionFeature } from '@/common/reward/types';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.BUNDLE.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = useAvatarBundleList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Gender', key: 'gender', options: AvatarBundleOptions.Gender },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: AvatarBundleOptions.Status },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-shipping-fast',
                        theme: 'info',
                        tooltip: 'Add special shop',
                        to: {
                            name: ROUTE_NAME_ITEM.SYSTEM.ADD,
                            query: { feature: InjectionFeature.AvatarBundle, data: row.id }
                        }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_AVATAR.BUNDLE.EDIT, params: { bundleId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-leaf',
                        theme: 'info',
                        tooltip: 'View items',
                        to: { name: ROUTE_NAME_AVATAR.BUNDLE.ITEM, params: { bundleId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, actions, ROUTE_NAME_AVATAR };
    }
});
